import { c as _c } from "react/compiler-runtime";
import * as RadixDropdown from '@radix-ui/react-dropdown-menu';
import { cx } from 'class-variance-authority';
import { forwardRef } from 'react';
import type { ContentProps } from '../dropdown.types';
const Content = forwardRef<HTMLDivElement, ContentProps>((t0, ref) => {
  const $ = _c(13);
  let children;
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      sideOffset: t1,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
  }
  const sideOffset = t1 === undefined ? 4 : t1;
  let t2;
  if ($[5] !== className) {
    t2 = cx("min-w-[120px] max-w-[min(360px,calc(100vw-32px))]", "bg-elevated rounded-default border border-tertiary origin-[var(--radix-dropdown-menu-content-transform-origin)] overflow-auto z-[60] shadow-md", "data-[side=bottom]:animate-[slideDown_var(--duration-ultra-fast)]", "data-[side=top]:animate-[slideUp_var(--duration-ultra-fast)]", "data-[side=left]:animate-[slideRight_var(--duration-ultra-fast)]", "data-[side=right]:animate-[slideLeft_var(--duration-ultra-fast)]", "data-[state=open]:animate-[scaleIn_var(--duration-ultra-fast)]", "data-[state=closed]:animate-[scaleOut_var(--duration-ultra-fast)]", className);
    $[5] = className;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== children || $[8] !== props || $[9] !== ref || $[10] !== sideOffset || $[11] !== t2) {
    t3 = <RadixDropdown.Content ref={ref} sideOffset={sideOffset} className={t2} {...props}>{children}</RadixDropdown.Content>;
    $[7] = children;
    $[8] = props;
    $[9] = ref;
    $[10] = sideOffset;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
});
export default Content;